import { API_AUTH } from ".././common";

const DsGoiVayApi = {
  list: ({ sSearch, iPageIndex, iPageSize}) =>
    API_AUTH.get(
      `danhsachgoivay/danhsach?sSearch=${sSearch}&iPageIndex=${iPageIndex}&iPageSize=${iPageSize}`,
      {}
    ),
  addOrUpdate: (params) => API_AUTH.post("danhsachgoivay/addorupdate", params),
  deleteGoiVay: ({ iGoiVay }) => API_AUTH.post("danhsachgoivay/delete?iGoiVay=" + iGoiVay),
  
  
};

export default DsGoiVayApi;
